'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _HelmetComponent = require('../../../components/common/HelmetComponent');

var _HelmetComponent2 = _interopRequireDefault(_HelmetComponent);

var _MultiFormContainer = require('../../common/MultiFormContainer');

var _MultiFormContainer2 = _interopRequireDefault(_MultiFormContainer);

var _GetQuoteContainer = require('./GetQuoteContainer');

var _GetQuoteContainer2 = _interopRequireDefault(_GetQuoteContainer);

var _ConfirmationContainer = require('../../common/ConfirmationContainer');

var _ConfirmationContainer2 = _interopRequireDefault(_ConfirmationContainer);

var _MshActionCreators = require('../../../actions/MshActionCreators');

var _translate = require('../../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders the entire form with all sub-pages.
 * @extends {Component}
 */
var LivExpatComponent = function (_React$Component) {
  _inherits(LivExpatComponent, _React$Component);

  function LivExpatComponent() {
    _classCallCheck(this, LivExpatComponent);

    return _possibleConstructorReturn(this, (LivExpatComponent.__proto__ || Object.getPrototypeOf(LivExpatComponent)).apply(this, arguments));
  }

  _createClass(LivExpatComponent, [{
    key: 'componentWillMount',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var auth;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (0, _translate.setLocale)(this.props.params.language);
                _context.next = 3;
                return this.props.getAuth('livexpat', this.props.params.language);

              case 3:
                auth = _context.sent;

                this.props.getFormConfig('livexpat', 'livexpat', this.props.params.language, auth.payload.data);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentWillMount() {
        return _ref.apply(this, arguments);
      }

      return componentWillMount;
    }()
  }, {
    key: 'render',
    value: function render() {
      return this.props.formConfigLoaded && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_HelmetComponent2.default, { title: 'MSH International | LivExpat Corporate Request to Quote Form' }),
        _react2.default.createElement(
          _MultiFormContainer2.default,
          {
            headerTitle: (0, _translate.t)('LivExpat Request to Quote Form'),
            headerProps: {
              logos: [{
                src: 'https://s3.ca-central-1.amazonaws.com/msh-assets/insurance/msh.png',
                alt: (0, _translate.t)('MSH International') + '\u2122'
              }],
              progressBarProps: {
                progressText: [{
                  description: (0, _translate.t)('Get Quote')
                }]
              }
            }
          },
          _react2.default.createElement(_GetQuoteContainer2.default, {
            params: this.props.params,
            trackingCode: this.props.location.query.tracking_code,
            formConfigName: 'livexpat',
            formName: 'livexpat',
            provider: 'livexpat',
            countryMessage: (0, _translate.t)('Home country is required'),
            showPremium: true
          })
        )
      );
    }
  }]);

  return LivExpatComponent;
}(_react2.default.Component);

LivExpatComponent.propTypes = {
  params: _react2.default.PropTypes.object,
  getAuth: _react2.default.PropTypes.func.isRequired,
  getFormConfig: _react2.default.PropTypes.func.isRequired,
  formConfigLoaded: _react2.default.PropTypes.bool.isRequired,
  location: _react2.default.PropTypes.object
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    formConfigLoaded: state.formConfig.loaded
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getAuth: function getAuth() {
      return dispatch(_MshActionCreators.getAuthorization.apply(undefined, arguments));
    },
    getFormConfig: function getFormConfig() {
      return dispatch(_MshActionCreators.getFormConfiguration.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LivExpatComponent);


//////////////////
// WEBPACK FOOTER
// ./src/v2/containers/msh/livexpat/LivExpatContainer.jsx
// module id = 1693
// module chunks = 0